export const NO_NEEDS_ASSET_AGENT_IDS = ["3", "104", "7", "105", "6", "106"];
